// P2b tanda 6 (PARTE B) — panel "Estado de la ficha" (columna derecha de la
// ficha). PRESENTACIONAL: recibe el resultado del evaluador (utils/fichaEstado,
// recalculado en vivo por la ficha, sin red) y un onIr(destino) que navega a la
// pestaña y enfoca el campo.
// Tanda 7 (rediseño): cabecera con el número GRANDE y "de M" pequeño, barra con
// color por tramo (rojo <40%, ámbar <80%, verde ≥80%) y frase de estado; bloque
// "Pendientes" (obligatorias primero, en rojo y con la etiqueta "obligatoria")
// con SEGUNDA LÍNEA por regla (regla.detalle: qué falta EXACTAMENTE, calculado
// por el evaluador); "Cumplidas" colapsado con contador. En móvil la cabecera
// queda visible y los bloques nacen colapsados.
import React from 'react';
import { CircleAlert, CircleDashed, CheckCircle2, Clock } from 'lucide-react';
import './FichaEstadoPanel.css';

function tramoDe(pct) {
  if (pct < 40) return 'rojo';
  if (pct < 80) return 'ambar';
  return 'verde';
}

function fraseDe(pct, oblig) {
  if (oblig > 0) return 'Hay campos obligatorios sin llenar: sin ellos no se puede guardar.';
  if (pct >= 100) return 'Ficha completa. Así se vende mejor.';
  if (pct >= 80) return 'Casi lista: quedan pocos detalles.';
  if (pct >= 40) return 'Vas bien. Completa las pendientes para que la ficha venda sola.';
  return 'A la ficha le falta bastante: empieza por las de arriba.';
}

function Linea({ regla, icono, clase, onIr }) {
  const detalle = regla.cumplida ? '' : (regla.detalle || regla.mensaje || '');
  return (
    <li>
      <button type="button" className={`fep-linea ${clase}`} onClick={() => onIr && onIr(regla.destino)}>
        {icono}
        <span className="fep-linea-txt">
          <span className="fep-linea-nombre">
            {regla.nombre}
            {clase === 'fep-linea--oblig' && <em className="fep-tag-oblig">obligatoria</em>}
          </span>
          {detalle && <span className="fep-linea-detalle">{detalle}</span>}
        </span>
      </button>
    </li>
  );
}

export default function FichaEstadoPanel({ resultado, onIr }) {
  if (!resultado) return null;
  const { reglas, cumplidas, aplicables, pospuestas } = resultado;
  const oblig = reglas.filter((r) => r.aplicable && !r.pospuesta && r.nivel === 'obligatoria' && !r.cumplida);
  const recom = reglas.filter((r) => r.aplicable && !r.pospuesta && r.nivel === 'recomendada' && !r.cumplida);
  const listas = reglas.filter((r) => r.aplicable && !r.pospuesta && r.cumplida);
  const pct = aplicables > 0 ? Math.round((cumplidas / aplicables) * 100) : 0;
  const tramo = tramoDe(pct);
  const pendientes = oblig.length + recom.length;
  // Móvil: los bloques nacen colapsados (la cabecera siempre se ve). jsdom no
  // implementa matchMedia: sin él se asume escritorio (abiertos).
  const movil = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia('(max-width: 900px)').matches;

  return (
    <div className="fep" data-testid="ficha-estado-panel">
      <div className="fep-head">
        <div className="fep-num">
          <span className="fep-num-grande">{cumplidas}</span>
          <span className="fep-num-de">de {aplicables}</span>
        </div>
        <div className="fep-headtxt">
          <div className="fep-barra" role="progressbar" aria-valuenow={cumplidas} aria-valuemin={0} aria-valuemax={aplicables}
            aria-label={`Estado de la ficha: ${cumplidas} de ${aplicables}`}>
            <div className={`fep-barra-relleno fep-barra--${tramo}`} style={{ width: `${pct}%` }} />
          </div>
          <p className="fep-frase">{fraseDe(pct, oblig.length)}</p>
        </div>
      </div>

      {(pendientes > 0 || pospuestas.length > 0) && (
        <details className="fep-bloque fep-bloque--pend" open={!movil}>
          <summary>Pendientes ({pendientes})</summary>
          <ul className="fep-lista">
            {oblig.map((r) => (
              <Linea key={r.id} regla={r} clase="fep-linea--oblig" onIr={onIr}
                icono={<CircleAlert size={14} aria-hidden="true" />} />
            ))}
            {recom.map((r) => (
              <Linea key={r.id} regla={r} clase="fep-linea--recom" onIr={onIr}
                icono={<CircleDashed size={14} aria-hidden="true" />} />
            ))}
            {pospuestas.map((r) => (
              <li key={r.id} className="fep-pospuesta">
                <Clock size={13} aria-hidden="true" /> {r.nombre}: después de guardar
              </li>
            ))}
          </ul>
        </details>
      )}

      {listas.length > 0 && (
        <details className="fep-bloque fep-bloque--ok fep-cumplidas">
          <summary>Ver cumplidas ({listas.length})</summary>
          <ul className="fep-lista">
            {listas.map((r) => (
              <Linea key={r.id} regla={r} clase="fep-linea--ok" onIr={onIr}
                icono={<CheckCircle2 size={14} aria-hidden="true" />} />
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
